const profileDefault = {
    exportWidth: 1920,
    exportHeight: 1080,
    scalePercent: 100,
    resizeMode: 'fixed_aspect',
    aspectRatio: { width: 16, height: 9 },
    exportFormat: 'jpeg',
    jpegQuality: 85,
    webpQuality: 85,
    avifQuality: 60,
    pngTransparency: true,
    enableSharpening: false,
    adaptiveSharpening: false,
    sharpenAmount: 120,
    sharpenRadius: 1.0,
    sharpenThreshold: 0
};

export default profileDefault;
